/**
 * Safety stock API: alias + row type for UI (OpenAPI generates ProductLocationSafetyStockService).
 * Keeps imports stable across `npm run generate:api`.
 *
 * Source of truth: scripts/openapi-extras/ — copied into src/api/services/ after codegen
 * (see scripts/fix-openapi.js).
 */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { ProductLocationSafetyStockService } from './ProductLocationSafetyStockService';
import type { BulkUpdateSelectedSafetyStockDto } from '../models/BulkUpdateSelectedSafetyStockDto';

export { ProductLocationSafetyStockService } from './ProductLocationSafetyStockService';

/** Row shape returned by GET /product-location-safety-stock (list view). */
export interface SafetyStockRow {
  id: number;
  productId: number;
  locationId: number;
  productCode: string;
  productName: string;
  sucursalName: string;
  tipoProducto?: string | null;
  stockDisponible?: number;
  stockSeguridad: number | null;
  estado?: string;
}

export class SafetyStockService extends ProductLocationSafetyStockService {
  /**
   * Bulk update safety stock for explicitly selected product-location pairs.
   */
  public static productLocationSafetyStockControllerBulkUpdateSelected(
    requestBody: BulkUpdateSelectedSafetyStockDto,
  ): CancelablePromise<{ updated?: number }> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/product-location-safety-stock/bulk/selection',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Location IDs already listed for a product (inventory or safety-stock config).
   */
  public static productLocationSafetyStockControllerGetAssignedLocationIds(
    productId: number,
  ): CancelablePromise<{ locationIds: number[] }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/product-location-safety-stock/products/{productId}/assigned-location-ids',
      path: { productId },
    });
  }
}
